(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hzw-collection-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hzw-collection-card')) {
  customElements.define('hzw-collection-card', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-hzw-variants]')?.textContent || '[]');
      this.swatches = this.querySelector('.hzw-card__swatches');
      this.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('.hzw-card__swatch input[type="radio"]')) return;
        const variant = this.variants.find(item => item.id === input.dataset.variantId);
        if (!variant) return;
        this.querySelector('.hzw-card__sale').textContent = variant.price;
        const compare = this.querySelector('.hzw-card__compare');
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
        this.fitPrices();
      }, { signal: this.abort.signal });
      // Always use the existing theme product popup; no direct cart request here.
      this.addEventListener('click', event => {
        const button = event.target.closest('.hzw-card__cart');
        if (!button || button.disabled || window.YGProductPopup?.openByHandle) return;
        // Graceful fallback if the theme popup script has not loaded.
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(button.dataset.productUrl);
      }, { signal: this.abort.signal });
      this.resize?.disconnect();
      this.resize = new ResizeObserver(() => { this.fitSwatches(); this.fitPrices(); });
      if (this.swatches) this.resize.observe(this.swatches);
      this.resize.observe(this.querySelector('.hzw-card__prices'));
      this.fitSwatches();
      this.fitPrices();
      document.fonts?.ready.then(() => { if (this.isConnected) this.fitPrices(); });
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    fitPrices() {
      const prices = this.querySelector('.hzw-card__prices');
      if (!prices?.clientWidth) return;
      const sale = this.querySelector('.hzw-card__sale');
      const compare = this.querySelector('.hzw-card__compare');
      sale.style.removeProperty('font-size');
      compare.style.removeProperty('font-size');
      const saleSize = parseFloat(getComputedStyle(sale).fontSize);
      const compareSize = parseFloat(getComputedStyle(compare).fontSize);
      const gap = compare.hidden ? 0 : parseFloat(getComputedStyle(prices).columnGap) || 0;
      const textWidth = sale.getBoundingClientRect().width + (compare.hidden ? 0 : compare.getBoundingClientRect().width);
      const scale = Math.min(1, Math.max(0, prices.clientWidth - gap - 1) / Math.max(1, textWidth));
      if (scale < 1) {
        sale.style.fontSize = `${saleSize * scale}px`;
        compare.style.fontSize = `${compareSize * scale}px`;
      }
    }
    fitSwatches() {
      if (!this.swatches || !this.swatches.clientWidth) return;
      const width = this.swatches.clientWidth - 6;
      const count = Math.max(0, Math.floor((width + 8) / 34));
      this.querySelectorAll('.hzw-card__swatch').forEach((swatch, index) => {
        swatch.hidden = index >= count;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hzw-featured-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hzw-featured-buy-now')) {
  customElements.define('hzw-featured-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.button = this.querySelector('button');
      this.status = this.querySelector('[data-status]');
      this.button.addEventListener('click', () => this.buy(), { signal: this.abort.signal });
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.form.addEventListener('cart:error', () => {
        clearTimeout(this.timer);
        delete this.form.dataset.hzwCheckout;
        this.pending = false;
        this.removeAttribute("data-pending");
        this.button.removeAttribute('aria-busy');
        this.sync();
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        clearTimeout(this.timer);
        delete this.form.dataset.hzwCheckout;
        this.pending = false;
        this.removeAttribute('data-pending');
        this.button.removeAttribute('aria-busy');
        this.sync();
      }, { signal: this.abort.signal });
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
    submitButton() {
      return [...(this.form?.elements || [])].find(el => el.matches('button[type="submit"], input[type="submit"]'));
    }
    sync() {
      const submit = this.submitButton();
      this.button.disabled = !!this.pending || !submit || submit.disabled || submit.getAttribute('aria-busy') === 'true';
    }
    buy() {
      this.form = document.getElementById(this.dataset.formId);
      const submit = this.submitButton();
      if (this.pending || !this.form || !submit || submit.disabled || this.form.dataset.hzwCheckout || submit.getAttribute('aria-busy') === 'true') return;
      if (!this.form.reportValidity()) return;
      this.pending = true;
      this.setAttribute("data-pending", "");
      this.status.hidden = true;
      this.form.dataset.hzwCheckout = 'true';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      // Click the existing ATC button so Kaching and the theme retain their normal submission pipeline.
      submit.click();
      this.timer = setTimeout(() => {
        delete this.form.dataset.hzwCheckout;
        this.button.removeAttribute('aria-busy');
        this.removeAttribute('data-pending');
        this.status.textContent = 'Checkout could not be confirmed. Please check your cart before trying again.';
        this.status.hidden = false;
        // Do not auto-retry: the first request may already have added products.
      }, 30000);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
    #observedSection = null;
    static observer = null;
    static sectionToItem = new Map();
    static isScroll = false;
    static scrollEndTimer = 0;
    static scrollToken = 0;
    static pendingSectionNumber = 0;
    static pendingLockUntil = 0;
    static scrollSpyBound = false;
    static scrollSpyRaf = 0;

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.sections = null;
    }

    connectedCallback() {
      this._refreshSections();
      this.addEventListener('click', this.itemClick);
      this._observeTarget();
      YGAnchorItem.#ensureScrollSpy();
      if (this._isActivityNavItem()) {
        YGAnchorItem.syncStickyNavFromScroll();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
      this._unobserveTarget();
    }

    _refreshSections() {
      this.sections = YGAnchorItem.getMainSections();
    }

    _isActivityNavItem() {
      return Boolean(this.closest('.yg-page-activity-anchor-nav'));
    }

    _isTabGroupItem() {
      if (this._isActivityNavItem()) return false;
      if (this.getAttribute('data-id')) return true;
      const siblings = this.parentElement?.querySelectorAll(':scope > yg-anchor-item');
      return Boolean(siblings && siblings.length > 1);
    }

    _observeTarget() {
      this._unobserveTarget();
      this._refreshSections();
      if (!this._isTabGroupItem()) return;

      const section = YGAnchorItem.resolveItemTarget(this);
      if (!section || !YGAnchorItem.isContentSection(section)) return;

      this.#observedSection = section;
      YGAnchorItem.#ensureObserver();
      YGAnchorItem.sectionToItem.set(section, this);
      YGAnchorItem.observer.observe(section);
    }

    _unobserveTarget() {
      if (!this.#observedSection || !YGAnchorItem.observer) return;
      YGAnchorItem.sectionToItem.delete(this.#observedSection);
      YGAnchorItem.observer.unobserve(this.#observedSection);
      this.#observedSection = null;
    }

    static getMainSections() {
      return document.querySelectorAll('#main > .shopify-section:not(.shopify-section-group-footer-group)');
    }

    static normalizeSectionId(rawId) {
      return String(rawId || '')
        .trim()
        .replace(/^#/, '');
    }

    static findSectionById(rawId) {
      const value = YGAnchorItem.normalizeSectionId(rawId);
      if (!value) return null;

      const ids = [value];
      if (!value.startsWith('shopify-section-')) {
        ids.push(`shopify-section-${value}`);
      }

      for (const id of ids) {
        const el = document.getElementById(id);
        if (el instanceof HTMLElement) return el.closest('.shopify-section') || el;
      }

      const sections = YGAnchorItem.getMainSections();
      for (const section of sections) {
        if (!section.id) continue;
        if (section.id === value) return section;
        if (section.id.endsWith(`__${value}`)) return section;
      }

      return null;
    }

    static getSectionNumberForElement(section) {
      if (!(section instanceof HTMLElement)) return 0;
      const sections = YGAnchorItem.getMainSections();
      const index = Array.prototype.indexOf.call(sections, section);
      return index >= 0 ? index + 1 : 0;
    }

    static resolveItemTarget(item) {
      if (!(item instanceof HTMLElement)) return null;

      const sectionId = item.getAttribute('data-section-id');
      if (sectionId && sectionId.trim()) {
        return YGAnchorItem.findSectionById(sectionId);
      }

      const sectionNumber = Number(item.getAttribute('data-section-number') || 0);
      if (!Number.isFinite(sectionNumber) || sectionNumber <= 0) return null;
      return YGAnchorItem.getMainSections()[sectionNumber - 1] || null;
    }

    static getItemTargetNumber(item) {
      const section = YGAnchorItem.resolveItemTarget(item);
      if (section) {
        const number = YGAnchorItem.getSectionNumberForElement(section);
        if (number > 0) return number;
      }

      if (item?.getAttribute('data-section-id')) return 0;
      return Number(item?.getAttribute('data-section-number') || 0);
    }

    static isContentSection(section) {
      if (!(section instanceof HTMLElement)) return false;
      if (section.classList.contains('yg-page-activity-floating-cart-section')) return false;
      if (section.classList.contains('yg-page-activity-anchor-nav-section')) return false;
      if (section.classList.contains('yg-page-activity-promo-bar-section')) return false;
      return section.offsetHeight >= 2;
    }

    static getStickyNav() {
      return document.querySelector('.yg-page-activity-anchor-nav-section');
    }

    static getStickyNavOffset() {
      const stickyNav = YGAnchorItem.getStickyNav();
      return stickyNav ? parseFloat(getComputedStyle(stickyNav).top) || 0 : 0;
    }

    static getHeaderHideCompensation(destinationY) {
      if (!Number.isFinite(destinationY) || destinationY <= window.scrollY + 8) return 0;

      const header = document.querySelector('store-header[hide-on-scroll]');
      if (!header) return 0;

      const root = getComputedStyle(document.documentElement);
      const stickyEnabled = parseFloat(root.getPropertyValue('--sticky-header-enabled')) || 0;
      const headerVisible = parseFloat(root.getPropertyValue('--header-is-visible')) || 1;
      const headerHeight = parseFloat(root.getPropertyValue('--header-height')) || 0;
      if (!stickyEnabled || headerVisible < 0.5 || headerHeight <= 0) return 0;

      const threshold = parseInt(header.getAttribute('hide-on-scroll') || '100', 10) || 100;
      if (destinationY - window.scrollY <= threshold) return 0;

      return headerHeight * headerVisible;
    }

    static getPinnedNavCoverage(sectionNumber = 0) {
      const stickyNav = YGAnchorItem.getStickyNav();
      if (!stickyNav) return 8;

      const stickyTop = YGAnchorItem.getStickyNavOffset();
      const sections = YGAnchorItem.getMainSections();
      const navIndex = Array.prototype.indexOf.call(sections, stickyNav);
      const targetIndex = sectionNumber - 1;
      const includeNav = !sectionNumber || navIndex < 0 || targetIndex > navIndex;

      return stickyTop + (includeNav ? stickyNav.offsetHeight : 0) + 8;
    }

    static getPreviousFlowSection(section) {
      let prev = section.previousElementSibling;
      while (prev) {
        const style = getComputedStyle(prev);
        if (
          prev.offsetHeight >= 2 &&
          style.position !== 'fixed' &&
          style.display !== 'none' &&
          style.visibility !== 'hidden'
        ) {
          return prev;
        }
        prev = prev.previousElementSibling;
      }
      return null;
    }

    static getSectionPageTop(section) {
      if (!(section instanceof HTMLElement)) return 0;

      const visualTop = section.getBoundingClientRect().top + window.scrollY;
      const position = getComputedStyle(section).position;
      if (position !== 'sticky' && position !== 'fixed') return visualTop;

      const prev = YGAnchorItem.getPreviousFlowSection(section);
      if (prev) return prev.getBoundingClientRect().bottom + window.scrollY;

      let top = 0;
      for (let node = section; node; node = node.offsetParent) {
        top += node.offsetTop;
      }
      return top > 0 ? top : visualTop;
    }

    static getScrollTopForSection(sectionNumber, sectionEl = null) {
      const section =
        sectionEl ||
        (Number.isFinite(sectionNumber) && sectionNumber > 0
          ? YGAnchorItem.getMainSections()[sectionNumber - 1]
          : null);
      if (!section) return 0;

      const number =
        Number.isFinite(sectionNumber) && sectionNumber > 0
          ? sectionNumber
          : YGAnchorItem.getSectionNumberForElement(section);
      const pageTop = YGAnchorItem.getSectionPageTop(section);
      const base = Math.max(0, pageTop - YGAnchorItem.getPinnedNavCoverage(number));
      const compensation = YGAnchorItem.getHeaderHideCompensation(base);

      return Math.max(0, base + compensation);
    }

    static getScrollMarker() {
      const stickyNav = YGAnchorItem.getStickyNav();
      if (!stickyNav) return Math.round(window.innerHeight * 0.22);

      const stickyTop = YGAnchorItem.getStickyNavOffset();
      const navRect = stickyNav.getBoundingClientRect();
      const pinnedBottom = Math.max(navRect.bottom, stickyTop + stickyNav.offsetHeight);
      return pinnedBottom + 8;
    }

    static getCurrentSectionNumber() {
      const sections = YGAnchorItem.getMainSections();
      const marker = YGAnchorItem.getScrollMarker();
      let current = 0;

      sections.forEach((section, index) => {
        if (!YGAnchorItem.isContentSection(section)) return;
        const top = YGAnchorItem.getSectionPageTop(section) - window.scrollY;
        if (top <= marker + 4) current = index + 1;
      });

      return current;
    }

    static #ensureScrollSpy() {
      if (YGAnchorItem.scrollSpyBound) return;
      YGAnchorItem.scrollSpyBound = true;

      const onScroll = () => {
        if (YGAnchorItem.isScroll || YGAnchorItem.scrollSpyRaf) return;
        if (performance.now() < YGAnchorItem.pendingLockUntil) return;

        YGAnchorItem.scrollSpyRaf = window.requestAnimationFrame(() => {
          YGAnchorItem.scrollSpyRaf = 0;
          if (YGAnchorItem.isScroll || performance.now() < YGAnchorItem.pendingLockUntil) return;
          YGAnchorItem.pendingSectionNumber = 0;
          YGAnchorItem.syncStickyNavFromScroll();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
    }

    static #ensureObserver() {
      if (YGAnchorItem.observer) return;

      YGAnchorItem.observer = new IntersectionObserver(
        (entries) => {
          if (YGAnchorItem.isScroll || performance.now() < YGAnchorItem.pendingLockUntil) return;

          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
          const item = visible.length ? YGAnchorItem.sectionToItem.get(visible[0].target) : null;
          if (!item || item.closest('.yg-page-activity-anchor-nav')) return;
          item.setActiveFromObserver();
        },
        {
          root: null,
          threshold: [0.08, 0.25, 0.5, 0.75],
          rootMargin: '-18% 0px -62% 0px',
        }
      );
    }

    static #endProgrammaticScroll(sectionNumber = 0) {
      window.clearTimeout(YGAnchorItem.scrollEndTimer);

      const target = Number(sectionNumber) || YGAnchorItem.pendingSectionNumber || 0;
      if (target > 0) {
        YGAnchorItem.syncStickyNav(target, { instant: true });
      } else {
        YGAnchorItem.syncStickyNavFromScroll();
      }

      YGAnchorItem.isScroll = false;
      YGAnchorItem.pendingLockUntil = performance.now() + 320;
    }

    static scrollToSection(sectionNumber, sectionEl = null) {
      const token = ++YGAnchorItem.scrollToken;
      const target = Number(sectionNumber) || (sectionEl ? YGAnchorItem.getSectionNumberForElement(sectionEl) : 0);

      YGAnchorItem.isScroll = true;
      YGAnchorItem.pendingSectionNumber = Math.max(target, 0);
      YGAnchorItem.pendingLockUntil = Number.POSITIVE_INFINITY;
      YGAnchorItem.syncStickyNav(YGAnchorItem.pendingSectionNumber, { instant: true });

      const top = YGAnchorItem.getScrollTopForSection(target, sectionEl);
      let done = false;

      const finish = () => {
        if (done || token !== YGAnchorItem.scrollToken) return;
        done = true;
        window.removeEventListener('scrollend', finish);
        YGAnchorItem.#endProgrammaticScroll(target);
      };

      window.scrollTo({ top, behavior: 'smooth' });
      window.addEventListener('scrollend', finish, { once: true });
      window.clearTimeout(YGAnchorItem.scrollEndTimer);

      const started = performance.now();
      let lastY = window.scrollY;
      let stillFrames = 0;
      let moved = false;
      const poll = () => {
        if (token !== YGAnchorItem.scrollToken) return;

        const y = window.scrollY;
        if (Math.abs(y - lastY) >= 1) {
          moved = true;
          stillFrames = 0;
        } else {
          stillFrames += 1;
        }
        lastY = y;

        const reached = Math.abs(y - top) <= 4;
        const settled = moved && stillFrames >= 4;
        if (reached || settled || performance.now() - started > 3000) {
          finish();
          return;
        }

        YGAnchorItem.scrollEndTimer = window.setTimeout(poll, 50);
      };
      YGAnchorItem.scrollEndTimer = window.setTimeout(poll, 50);
    }

    static syncStickyNavFromScroll() {
      if (!document.querySelector('.yg-page-activity-anchor-nav')) return;
      const pending = YGAnchorItem.pendingSectionNumber;
      const sectionNumber =
        pending > 0 && (YGAnchorItem.isScroll || performance.now() < YGAnchorItem.pendingLockUntil)
          ? pending
          : YGAnchorItem.getCurrentSectionNumber();
      YGAnchorItem.syncStickyNav(sectionNumber, { instant: true });
    }

    static syncStickyNav(sectionNumber, options = {}) {
      if (!Number.isFinite(sectionNumber)) return;

      document.querySelectorAll('.yg-page-activity-anchor-nav__list').forEach((list) => {
        const items = Array.from(list.querySelectorAll('yg-anchor-item'));
        if (!items.length) return;

        const numbered = items.map((el) => ({ el, n: YGAnchorItem.getItemTargetNumber(el) })).sort((a, b) => a.n - b.n);

        let match = numbered[0]?.el || null;
        numbered.forEach((item) => {
          if (item.n <= sectionNumber) match = item.el;
        });
        if (!match) return;

        items.forEach((el) => {
          el.classList.toggle('active', el === match);
        });

        if (typeof match.labelClick === 'function') {
          match.labelClick(items.indexOf(match), Boolean(options.instant));
        }
      });
    }

    setActiveFromObserver(options = {}) {
      const instant = Boolean(options.instant);
      let id = this.getAttribute('data-id');
      let $anchorList;
      if (id) {
        $anchorList = this.parentElement
          ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
          : [];
      } else {
        $anchorList = this.parentElement ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item')) : [];
      }

      $anchorList.forEach((el, index) => {
        el.classList.toggle('active', el === this);

        if (el === this) {
          this.labelClick(index, instant);
        }
      });

      document.dispatchEvent(
        new CustomEvent('YG:anchor-change', {
          bubbles: true,
        })
      );
    }

    labelClick(index, instant = false) {
      const parent = this.parentElement;
      if (parent && this.isScrollable(parent)) {
        const targetLeft = this.offsetLeft;
        const targetWidth = this.offsetWidth;
        const containerWidth = parent.clientWidth;
        const maxScrollLeft = Math.max(0, parent.scrollWidth - containerWidth);
        const targetCenter = targetLeft + targetWidth / 2;
        const nextScrollLeft = targetCenter - containerWidth / 2;
        const scrollLeft = Math.min(Math.max(nextScrollLeft, 0), maxScrollLeft);

        parent.scrollTo({
          left: scrollLeft,
          behavior: instant ? 'auto' : 'smooth',
        });
      }
    }

    isScrollable(el) {
      if (!el) return false;

      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;

      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

      return canScrollVertically || canScrollHorizontally;
    }

    itemClick() {
      const section = YGAnchorItem.resolveItemTarget(this);
      const hasSectionId = Boolean(this.getAttribute('data-section-id')?.trim());
      if (hasSectionId && !section) return;

      const sectionNumber = YGAnchorItem.getItemTargetNumber(this);

      if (this._isTabGroupItem() || this._isActivityNavItem()) {
        this.setActiveFromObserver({ instant: true });
      }

      YGAnchorItem.scrollToSection(sectionNumber, section);
    }
  }

  window.YGAnchorItem = YGAnchorItem;
  if (!window.customElements.get('yg-anchor-item')) {
    window.customElements.define('yg-anchor-item', YGAnchorItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }
    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = '0px';
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';

      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() { 
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === '0px') {
        // 已经是收起或未设置高度，直接返回
        target.removeAttribute('open');
        target.style.height = '0px';
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = '0px';
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-complementary-products"] && !Shopify.designMode) return;
  try {
    class YgComplementaryProducts extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-role="toggle"]');
      this.rows = Array.from(this.querySelectorAll('.yg-complementary__item'));
      this.#applySwatchColors();
      this.#bindSwatches();
      this.#bindToggle();
      this.#bindAddButtons();
    }

    #bindToggle() {
      if (!this.toggleButton) {
        return;
      }

      this.toggleLabel = this.toggleButton.querySelector('[data-role="toggle-label"]');

      this.toggleButton.addEventListener('click', () => {
        const expanded = this.toggleButton.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        this.toggleButton.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

        this.rows.forEach((row, index) => {
          if (index < 2) {
            return;
          }
          row.hidden = !nextExpanded;
        });

        if (!this.toggleLabel) {
          return;
        }

        const showMore = this.toggleButton.dataset.showMore;
        const showLess = this.toggleButton.dataset.showLess;
        if (nextExpanded) {
          this.toggleLabel.textContent = showLess || this.toggleLabel.textContent;
        } else {
          this.toggleLabel.textContent = showMore || this.toggleLabel.textContent;
        }
      });
    }

    #bindSwatches() {
      this.rows.forEach((row) => {
        const swatches = Array.from(row.querySelectorAll('.yg-complementary__swatch'));
        if (swatches.length === 0) {
          return;
        }

        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            swatches.forEach((item) => {
              item.classList.remove('is-selected');
              item.setAttribute('aria-checked', 'false');
            });

            swatch.classList.add('is-selected');
            swatch.setAttribute('aria-checked', 'true');

            const variantId = swatch.getAttribute('data-variant-id');
            const price = Number(swatch.getAttribute('data-price') || 0);
            const compareAtPrice = Number(swatch.getAttribute('data-compare-at-price') || 0);

            const addButton = row.querySelector('[data-role="add"]');
            if (addButton && variantId) {
              addButton.setAttribute('data-variant-id', variantId);
            }

            const priceElement = row.querySelector('[data-role="price"]');
            const compareElement = row.querySelector('[data-role="compare"]');

            if (priceElement) {
              priceElement.textContent = this.#formatMoney(price);
            }

            if (compareElement) {
              if (compareAtPrice > price) {
                compareElement.innerHTML = `<s>${this.#formatMoney(compareAtPrice)}</s>`;
              } else {
                compareElement.innerHTML = '';
              }
            }
          });
        });
      });
    }

    #bindAddButtons() {
      this.querySelectorAll('[data-role="add"]').forEach((button) => {
        button.addEventListener('click', async () => {
          const variantId = button.getAttribute('data-variant-id');
          if (!variantId) {
            return;
          }

          const addLabel = button.getAttribute('data-label-add') || '';
          const addedLabel = button.getAttribute('data-label-added') || '';
          const labelElement = button.querySelector('[data-role="add-label"]');

          try {
            button.setAttribute('aria-busy', 'true');
            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                  },
                ],
              }),
            });

            if (!response.ok) {
              throw new Error('Add to cart failed');
            }

            button.classList.add('is-added');
            if (labelElement && addedLabel) {
              labelElement.textContent = addedLabel;
            }

            const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart,
                },
              })
            );

            window.setTimeout(() => {
              button.classList.remove('is-added');
              if (labelElement && addLabel) {
                labelElement.textContent = addLabel;
              }
            }, 1200);
          } catch (error) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } finally {
            button.removeAttribute('aria-busy');
          }
        });
      });
    }

    #applySwatchColors() {
      const swatchMap = {
        black: '#000000',
        schwarz: '#000000',
        gray: '#8e8e8e',
        grey: '#8e8e8e',
        grau: '#8e8e8e',
        white: '#ffffff',
        weiss: '#ffffff',
        weiß: '#ffffff',
        blue: '#6ca5ff',
        green: '#6fa079',
        pink: '#f7b8c9',
        orange: '#ff7a2f',
        silver: '#c0c0c0',
        clear: '__checker__',
        transparent: '__checker__',
        klar: '__checker__',
        durchsichtig: '__checker__',
      };

      const hashColor = (value) => {
        let hash = 0;
        for (let i = 0; i < value.length; i += 1) {
          hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
        }
        return `hsl(${hash % 360} 55% 65%)`;
      };

      this.querySelectorAll('.yg-complementary__swatch').forEach((swatch) => {
        const raw = (swatch.getAttribute('data-color') || '').trim();
        const normalized = raw.toLowerCase().replace(/[^a-z0-9\u00C0-\u024f]+/g, '-');
        const mapped = swatchMap[normalized] || swatchMap[normalized.split('-')[0]];
        const colorValue = mapped || hashColor(normalized || raw || 'default');

        if (colorValue === '__checker__') {
          swatch.style.background = 'conic-gradient(#ddd 0 25%, #fff 0 50%, #ddd 0 75%, #fff 0)';
          swatch.style.backgroundSize = '8px 8px';
          return;
        }

        swatch.style.background = colorValue;
      });
    }

    #formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return (cents / 100).toFixed(2);
    }
  }

  if (!window.customElements.get('yg-complementary-products')) {
    window.customElements.define('yg-complementary-products', YgComplementaryProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.debouncedResize = this.debounce(() => this.setContentContainerHeight(), 100);
      }

      get dropdownGroup(){
        if(this.#dropdownGroup) return this.#dropdownGroup

        let groupID = this.dataset.group
        if (!groupID) return null

        this.#dropdownGroup = Array.from(this.closest('.shopify-section').querySelectorAll('yg-dropdown[data-group="' + groupID + '"]'))   
        
        return this.#dropdownGroup
      }
      connectedCallback() {
          setTimeout(() => {
            if (this.dropdownGroup?.length > 0) {
              this.dropdownGroup[0]?.openDropdown();
            }
          }, 60);
          this.titleContainer = this.querySelector('.yg-dropdown-title-container');
          if (this.titleContainer) {
            this.titleContainer.addEventListener('click', this.itemClick);
            window.addEventListener('resize', this.debouncedResize);
            this.setContentContainerHeight()
          }
      }
      disconnectedCallback() {
          if (this.titleContainer) {
            this.titleContainer.removeEventListener('click', this.itemClick);
          }
          if (this.debouncedResize) {
            window.removeEventListener('resize', this.debouncedResize);
          }
      }
      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion') && Array.isArray(group).length > 1) {
              this.closeDropdown();
            }
            return;
          }
   
          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      openDropdown(){
        let group = this.dropdownGroup;
        if (group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown();
                }
            });
        }
   
        this.setAttribute('open', '');
        document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('data-id')
          }
        }));
      }

      closeDropdown(){
        this.removeAttribute('open');
      }

      setContentContainerHeight(){
        let contentContainer = this.querySelector('.yg-dropdown-content-container');
        let content = this.querySelector('.yg-dropdown-content');
        if (contentContainer && content) {
          contentContainer.style.setProperty('--height', `${content.getBoundingClientRect().height}px`);
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-key-features"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-key-features-toggle]');

    if (!toggle) {
      return;
    }

    const keyFeatures = toggle.closest('[data-key-features]');
    const label = toggle.querySelector('[data-key-features-toggle-label]');

    if (!keyFeatures || !label) {
      return;
    }

    const expanded = !keyFeatures.classList.contains('is-expanded');
    keyFeatures.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    label.textContent = expanded ? label.dataset.showLess : label.dataset.showMore;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionsEl = {
        'popupTemplate': this.querySelector('template') || this.querySelector('.yg-popup-template')
      }
      this.addEventListener('click', this.itemClick.bind(this));
    }

    itemClick() {
      if (!this.sectionsEl['popupTemplate']) return

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: this.sectionsEl['popupTemplate'],
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ygProductCardPriceSyncBound) {
      return;
    }

    window.__ygProductCardPriceSyncBound = true;

    document.addEventListener('change', (event) => {
      const target = event.target;

      if (!(target instanceof HTMLInputElement)) {
        return;
      }

      if (!target.matches('.yg-product-card .product-card__swatch-list input[type="radio"]')) {
        return;
      }

      const card = target.closest('.yg-product-card');
      if (!card) {
        return;
      }

      const variantId = target.getAttribute('data-variant-id');
      const variantPrice = target.getAttribute('data-variant-price');
      const variantCompareAtPrice = target.getAttribute('data-variant-compare-at-price');
      const variantSave = target.getAttribute('data-variant-save');
      const variantAvailable = target.getAttribute('data-variant-available');

      const priceList = card.querySelector('.yg-product-card__price-list');
      const salePrice = priceList?.querySelector('sale-price');
      const compareAtPrice = priceList?.querySelector('compare-at-price');
      const saveBadge = card.querySelector('.yg-product-card__save');

      if (salePrice && variantPrice) {
        const saleLabel = priceList.getAttribute('data-sale-label') || '';
        salePrice.innerHTML = `<span class="sr-only">${saleLabel}</span>${variantPrice}`;
      }

      if (compareAtPrice) {
        if (variantCompareAtPrice) {
          const regularLabel = priceList.getAttribute('data-regular-label') || '';
          compareAtPrice.hidden = false;
          compareAtPrice.innerHTML = `<span class="sr-only">${regularLabel}</span>${variantCompareAtPrice}`;
        } else {
          compareAtPrice.hidden = true;
          compareAtPrice.innerHTML = '';
        }
      }

      if (saveBadge) {
        if (variantSave) {
          saveBadge.hidden = false;
          saveBadge.textContent = variantSave;
        } else {
          saveBadge.hidden = true;
          saveBadge.textContent = '';
        }
      }

      if (variantId) {
        const formIdInput = card.querySelector('.yg-product-card__quick-add-form input[name="id"]');
        if (formIdInput) {
          formIdInput.value = variantId;
        }

        const quickBuyDrawer = card.querySelector('quick-buy-drawer');
        if (quickBuyDrawer && card.getAttribute('handle')) {
          quickBuyDrawer.setAttribute('handle', `${card.getAttribute('handle')}?variant=${variantId}`);
        }
      }

      if (variantAvailable !== null) {
        const quickAddButton = card.querySelector('.yg-product-card__quick-add');
        if (quickAddButton) {
          const hasQuickBuyDrawer = Boolean(card.querySelector('quick-buy-drawer'));

          if (hasQuickBuyDrawer) {
            quickAddButton.disabled = false;
          } else {
            quickAddButton.disabled = variantAvailable !== 'true';
          }
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('.complementary-products__toggle');

    if (!toggleButton) {
      return;
    }

    const toggleTargetId = toggleButton.getAttribute('data-toggle-target');

    if (!toggleTargetId) {
      return;
    }

    const extraProducts = document.getElementById(toggleTargetId);

    if (!extraProducts) {
      return;
    }

    extraProducts.hidden = false;
    toggleButton.hidden = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-progress-bar"] && !Shopify.designMode) return;
  try {
    class YGProgressBar extends HTMLElement {
    #videoListenersAttached = false;

    constructor() {
      super();
      this.video = null;
      this.animationFrame = null;
    }

    connectedCallback() {
    }

    get isCircle() {
      return this.classList.contains('yg-progress-circle');
    }

    get circleProgressElement() {
      return this.querySelector('.circle-progress');
    }

    findVideo() {
      let isMobile = window.innerWidth < 699;
      let id = this.getAttribute('data-id');
      if (isMobile && this.getAttribute('data-mobile-id')) {
        id = this.getAttribute('data-mobile-id');
      }
      if (!id) return null;

      return document.querySelector(`yg-video[data-id="${id}"]`);
    }

    getVideoElement(videoComponent) {
      if (!videoComponent) return null;
      return videoComponent.querySelector('.yg-video-iframe');
    }

    syncWithVideo() {
      if (!this.video) return;

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) return;

      const duration = this.video.duration || videoEl.duration || 0;
      const currentTime = videoEl.currentTime || 0;

      if (duration > 0) {
        const progress = (currentTime / duration) * 100;
        
        if (this.isCircle) {
          this.syncCircleProgress(progress);
        } else {
          this.style.setProperty('--progress-width', `${progress}%`);
        }
      }
    }

    syncCircleProgress(progress) {
      const circleEl = this.circleProgressElement;
      if (!circleEl) return;

      const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
      const dashArray = (progress / 100) * circumference;
      circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
    }

    startProgress() {
      const id = this.getAttribute('data-id');
      this.video = this.findVideo();

      if (this.video) {
        this.startVideoProgress();
      } else {
        this.startAnimationProgress();
      }
    }

    startAnimationProgress() {
      const id = this.getAttribute('data-id');
      this.classList.add('start-progress');

      if (this.isCircle) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--duration')) || 10;
          const circumference = parseFloat(style.getPropertyValue('--circle-circumference')) || 100;
          
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = (timestamp - startTime) / 1000;
            const progress = Math.min(elapsed / duration, 1);
            
            const dashArray = progress * circumference;
            circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
            
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(animate);
            } else {
              this.stopProgress(true);
            }
          };
          
          this.animationFrame = requestAnimationFrame(animate);
        }
        return;
      }

      let handleAnimationEnd = () => {
        this.stopProgress(true);
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
    }

    startVideoProgress() {
      this.classList.add('video-sync');

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) {
        this.#waitForVideo();
        return;
      }

      this.#initVideoListeners(videoEl);

      if (!videoEl.paused) {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      }
    }

    #waitForVideo() {
      const observer = new MutationObserver(() => {
        const videoEl = this.getVideoElement(this.video);
        if (videoEl) {
          observer.disconnect();
          this.#initVideoListeners(videoEl);
          if (!videoEl.paused) {
            this.classList.add('playing');
            this.#startVideoUpdate(videoEl);
          }
        }
      });
      observer.observe(this.video, { childList: true, subtree: true });
    }

    #initVideoListeners(videoEl) {
      if (this.#videoListenersAttached) return;
      this.#videoListenersAttached = true;

      videoEl.addEventListener('play', () => {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      });

      videoEl.addEventListener('pause', () => {
        this.classList.remove('playing');
        this.#stopVideoUpdate();
      });

      videoEl.addEventListener('ended', () => {
        this.stopProgress(true);
      });

      videoEl.addEventListener('timeupdate', () => {
        this.syncWithVideo();
      });
    }

    #startVideoUpdate(videoEl) {
      this.#stopVideoUpdate();
      const updateProgress = () => {
        this.syncWithVideo();
        if (!videoEl.paused && !videoEl.ended) {
          this.animationFrame = requestAnimationFrame(updateProgress);
        }
      };
      updateProgress();
    }

    #stopVideoUpdate() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    stopProgress(completed = false) {
      this.classList.remove('start-progress', 'playing', 'video-sync');

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.isCircle && !completed) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
          circleEl.style.strokeDasharray = `0 ${circumference}`;
        }
      }

      if (completed) {
        const id = this.getAttribute('data-id');
        document.dispatchEvent(new CustomEvent('YG:progress-end', {
          bubbles: true,
          composed: true,
          detail: { id }
        }));
      }
    }
  }

  if (!window.customElements.get('yg-progress-bar')) {
    window.customElements.define('yg-progress-bar', YGProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'title-list': Array.from(this.children),
        'content-list': Array.from(
          document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || []
        ),
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      this.initTabs();
      this.addEventListener('click', this.handleClick);
      window.addEventListener('resize', this.handleResize);
      requestAnimationFrame(() => {
        this.updateStyle();
        this.scrollActiveTabIntoView(false);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('resize', this.handleResize);
    }

    initTabs() {
      this.sectionsEl['title-list']?.forEach((el, i) => {
        if (!el.classList.contains('tab-title')) {
          el.classList.add('tab-title');
        }

        if (i == 0) {
          el.classList.add('is-active');
        }
      });
      this.updateStyle(this.sectionsEl['title-list'][0]);

      this.sectionsEl['content-list'].forEach((el, i) => {
        if (!el.classList.contains('tab-content')) {
          el.classList.add('tab-content');
        }

        if (i == 0) el.classList.add('is-active');
      });

      requestAnimationFrame(() => {
        this.updateStyle(this.sectionsEl['title-list'][0]);
        this.scrollActiveTabIntoView(false);
      });
    }

    toggleClass(el, i) {
      // 处理标题激活状态
      this.sectionsEl['title-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      el.classList.add('is-active');
      this.updateStyle(el);

      // 处理内容激活状态
      this.sectionsEl['content-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      if (this.sectionsEl['content-list'][i]) this.sectionsEl['content-list'][i].classList.add('is-active');
    }

    handleClick(e) {
      let item = e.target.closest('.tab-title');
      if (!item) return;

      let i = this.sectionsEl['title-list'].indexOf(item);
      this.itemClick(item, i);
    }

    handleResize() {
      this.updateStyle();
      this.scrollActiveTabIntoView(false);
    }

    itemClick(el, i) {
      if (el.classList.contains('is-active')) return;

      this.toggleClass(el, i);
      this.scrollToTab(el);
    }

    updateStyle(el = null) {
      let itemEl = el || this.querySelector('.is-active');

      if (!itemEl) return;
      let left = itemEl.offsetLeft;
      let width = itemEl.offsetWidth;
      this.style.setProperty('--scroll-item-left', `${left}px`);
      this.style.setProperty('--scroll-item-width', `${width}px`);
    }

    scrollActiveTabIntoView(smooth = true) {
      this.scrollToTab(this.querySelector('.is-active'), smooth);
    }

    scrollToTab(el, smooth = true) {
      let parent = this.closest('.yg-scroll-container');
      if (!el || !parent || !this.isScrollable(parent)) return;

      let containerRect = parent.getBoundingClientRect();
      let targetRect = el.getBoundingClientRect();
      let scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 20;

      parent.scrollTo({
        left: Math.max(scrollLeft, 0),
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    isScrollable(el) {
      if (!el) return false;

      return el.scrollWidth > el.clientWidth;
    }
  }
  if (!window.customElements.get('yg-tabs-title')) {
    window.customElements.define('yg-tabs-title', YGTabsTitle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', () => this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState('play');
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach((video) => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (video.duration && video.currentTime >= video.duration && this.loop == 'false') {
              this.switcherVideoButtonState('pause');
            }
          });
        });

        return;
      }
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState('pause');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach((video) => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState(state = 'play') {
      if (state == 'pause') {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == 'play') {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
